import React from 'react';
interface AvatarProps {
  name: string;
  size?: 'sm' | 'md';
}
export function Avatar({
  name,
  size = 'sm'
}: AvatarProps) {
  const initials = name.split(' ').map(p => p[0]).join('').slice(0, 2).toUpperCase();
  const colors = ['bg-blue-100 text-blue-700', 'bg-emerald-100 text-emerald-700', 'bg-purple-100 text-purple-700', 'bg-amber-100 text-amber-700', 'bg-rose-100 text-rose-700', 'bg-indigo-100 text-indigo-700', 'bg-teal-100 text-teal-700', 'bg-violet-100 text-violet-700', 'bg-cyan-100 text-cyan-700'];
  const charCode = name.length > 0 ? name.charCodeAt(0) : 0;
  const color = colors[charCode % colors.length];
  const sizeClass = size === 'md' ? 'w-10 h-10 text-sm' : 'w-7 h-7 text-xs';
  return <div className={`${sizeClass} rounded-full ${color} flex items-center justify-center font-semibold flex-shrink-0`} data-id="element-4386">
      {initials || '?'}
    </div>;
}